import { render, staticRenderFns } from "./WatchlistModal.vue?vue&type=template&id=b98ecc24&scoped=true&"
import script from "./WatchlistModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WatchlistModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WatchlistModal.vue?vue&type=style&index=0&id=b98ecc24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98ecc24",
  null
  
)

export default component.exports